import { Route, Routes } from 'react-router-dom';
import { BannersPage } from './BannersPage';
import { ModifyBannerPage } from './ModifyBannerPage';

export const BannerPageRoot = () => (
  <Routes>
    <Route path='/new' element={<ModifyBannerPage />} />
    <Route path='/:bannerID' element={<ModifyBannerPage />} />
    <Route path='*' element={<BannersPage />} />
  </Routes>
);
